import { EmploymentPeriodViewModel, EmploymentViewModelNew } from '@fora-monorepo/employer-my-pages-common/types';
import {
  Assets,
  Box,
  Button,
  Container,
  DateWithDots,
  Flex,
  Headings,
  Link,
  Text,
  VerticalSpacer,
} from '@foradevelopment/fora-ui';

import { PersonDetails } from '../../components';
import { useTypedTranslation } from '../../i18n/i18n';
import { links } from '../../router/links';
import { getParameterTKeys } from '../../common/utils';

type EditParameterConfirmationDetailsProps = {
  resetPanels: () => void;
  employment: EmploymentViewModelNew;
  employmentPeriod?: EmploymentPeriodViewModel;
};

export const EditParameterConfirmationDetails = ({
  resetPanels,
  employment,
  employmentPeriod,
}: EditParameterConfirmationDetailsProps) => {
  const { t } = useTypedTranslation();

  const { employee } = employment;

  return (
    <Container maxWidth={578} width="100%">
      <Assets.CheckmarkIcon color="black" width={30} />
      <VerticalSpacer marginBottom={10} />
      <Headings.H2>{t('panel.employeeAddedOrUpdated.confirmationEditText')}</Headings.H2>
      <VerticalSpacer marginBottom={60} />
      <PersonDetails {...employee} />
      <VerticalSpacer marginBottom={60} />
      <Container>
        <Flex justifyContent="space-between" alignItems="center">
          <Headings.H4>{t('list.markupAndParametersList.parameterTitle')}</Headings.H4>
          <Box>
            <Button styleAs="link" resetFlexProps onClick={resetPanels}>
              {t('common.edit')} <Assets.EditIcon marginLeft={5} />
            </Button>
          </Box>
        </Flex>
        <VerticalSpacer marginBottom={20} />
        {employmentPeriod?.fokParameterChoices.map(fokParameterChoice => {
          const { name } = getParameterTKeys(fokParameterChoice.parameterValue);
          return (
            <>
              <Headings.H5 styleAs="h6">{t(name)}</Headings.H5>
              {fokParameterChoice.endDate && (
                <>
                  <VerticalSpacer marginBottom={6} />
                  <DateWithDots text={t('common.endDate')} date={fokParameterChoice.endDate} backgroundColor="white" />
                </>
              )}
              <VerticalSpacer marginBottom={20} />
            </>
          );
        })}
        <Text color="black70">{t('list.markupAndParametersList.parameterStartInfo')}</Text>
      </Container>
      <VerticalSpacer marginBottom={60} />
      <Container>
        <Flex rowGap={20} columnGap={20} flexWrap="wrap">
          <Link variant="primary" styleAs="button" to={links.employments} hasIcon={false} fullWidth={false}>
            {t('panel.employeeAddedOrUpdated.buttonTextShowAllEmployments')}
          </Link>
        </Flex>
      </Container>
    </Container>
  );
};
